import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=267de957"
import script from "./Sticky.vue?vue&type=script&lang=js"
export * from "./Sticky.vue?vue&type=script&lang=js"
import style0 from "./Sticky.vue?vue&type=style&index=0&id=267de957&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports